'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BlockStyleControls = require('./BlockStyleControls');

var _BlockStyleControls2 = _interopRequireDefault(_BlockStyleControls);

var _InlineStyleControls = require('./InlineStyleControls');

var _InlineStyleControls2 = _interopRequireDefault(_InlineStyleControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorControls = function EditorControls(props) {
	var editorState = props.editorState,
	    toggleInlineStyle = props.toggleInlineStyle,
	    toggleBlockType = props.toggleBlockType;

	return _react2.default.createElement(
		'div',
		{ className: 'editor-controls' },
		_react2.default.createElement(_BlockStyleControls2.default, {
			editorState: editorState,
			onToggle: toggleBlockType
		}),
		_react2.default.createElement(_InlineStyleControls2.default, {
			editorState: editorState,
			onToggle: toggleInlineStyle
		})
	);
};

exports.default = EditorControls;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/EditorControls.js
// module id = 576
// module chunks = 0